export const runAfterLayout = (callback: () => void) => {
  let innerFrame: number | null = null;

  const outerFrame = window.requestAnimationFrame(() => {
    innerFrame = window.requestAnimationFrame(callback);
  });

  return () => {
    window.cancelAnimationFrame(outerFrame);

    if (innerFrame !== null) {
      window.cancelAnimationFrame(innerFrame);
    }
  };
};
